import React, { useState, useContext, useEffect } from 'react'
import { CCarousel, CCarouselItem, CImage } from '@coreui/react'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../../../contexts/Auth'
import { saveHistoryAccess } from '../../../services/saveHistoryAccess'
import {
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CToast,
  CToastBody,
  CToastClose,
} from '@coreui/react'
import CircularProgress from '@mui/material/CircularProgress'
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'
import RecoverPassword from './recover-password/RecoverPassword'
import { api } from '../../../services/api'
import './Login.css'
import DevTag from './components/DevTag'
import SitTag from './components/SitTag'

const imageCarousel = [
  'assets/images/carousel/header_1.jpg',
  'assets/images/carousel/header_2.jpg',
  'assets/images/carousel/header_3.jpg',
  'assets/images/carousel/header_4.jpg',
  'assets/images/carousel/header_5.jpg',
]

const Login = () => {
  const { logoutSystem } = useContext(AuthContext)
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [loginAlert, setLoginAlert] = useState(false)
  const [loginAlertMessage, setLoginAlertMessage] = useState('')
  const [alertAnimationClass, setAlertAnimationClass] = useState('animate__fadeInTopRight')
  const [recoverPassword, setRecoverPassword] = useState(false)
  const [environment, setEnvironment] = useState('')
  const { login } = useContext(AuthContext)

  useEffect(() => {
    if (localStorage.getItem('token')) navigate('/dashboard')

    if (localStorage.getItem('refreshPage')) {
      localStorage.removeItem('refreshPage')
      window.location.reload(true)
    }

    if (api.defaults.baseURL.includes("portalfroneri-dev")) {
      setEnvironment('DEV');
    } else if (api.defaults.baseURL.includes("portalfroneri-sit")) {
      setEnvironment('SIT');
    }
    // eslint-disable-next-line
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    const responseLogin = await login(email, password)

    if (responseLogin === 'Access authorized!') {
      const result = await saveHistoryAccess(
        localStorage.getItem('tempUserId'),
        'Dashboard',
        'login',
        logoutSystem,
        '',
      )
      if (result === 'Histórico processado.') {
        localStorage.removeItem('tempUserId')
        navigate('/dashboard')
      }
    } else {
      setLoading(false)
      setLoginAlertMessage(responseLogin)
      setLoginAlert(true)
    }
  }

  const closeLoginAlert = () => {
    setAlertAnimationClass('animate__fadeOutTopRight')
    setTimeout(() => {
      setLoginAlert(false)
      setAlertAnimationClass('animate__fadeInTopRight')
    }, 1000)
  }

  return (
    <div className="split-screen">
      {!recoverPassword && (
        <>
          <div className="left container-login">
            <div className="container-pic-login-screen">
              <CCarousel controls indicators interval={4000} className="container-carousel-login">
                {imageCarousel.map((item, index) => {
                  return (
                    <CCarouselItem key={`carousel-${index}`} className="carousel-item-login">
                      <CImage
                        className="pic-login-screen"
                        src={item}
                        alt={`carousel-${index + 1}`}
                      />
                    </CCarouselItem>
                  )
                })}
              </CCarousel>
            </div>
            <div>
              <img src="assets/images/froneri-login.png" alt="Logo" className="logo-login" />
            </div>
          </div>
          <div className="right">
            <CForm onSubmit={handleSubmit}>
              <section className="copy">
                <div className="logo-welcome">
                {environment === 'DEV' && <DevTag />}
                {environment === 'SIT' && <SitTag />}
                  <img src="assets/images/logo.png" alt="Logo" className="logo-login" />
                </div>
                <h2>Bem vindo</h2>
              </section>
              <div className="input-container name">
                <CInputGroup className="mb-3">
                  <CInputGroupText className="icon-input-login">
                    <CIcon icon={cilUser} />
                  </CInputGroupText>
                  <CFormInput
                    className="input-login"
                    placeholder="Digite seu login*"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </CInputGroup>
              </div>
              <div className="input-container password">
                <CInputGroup className="mb-4">
                  <CInputGroupText className="icon-input-login">
                    <CIcon icon={cilLockLocked} />
                  </CInputGroupText>
                  <CFormInput
                    className="input-login"
                    type="password"
                    placeholder="Digite sua senha*"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </CInputGroup>
              </div>
              <div className="d-grid gap-2">
                <button className="signup-btn" type="submit" disabled={loading}>
                  {!loading && 'Entrar'}
                  {loading && (
                    <div>
                      <CircularProgress
                        sx={{
                          color: (theme) => '#fff',
                        }}
                        size={20}
                        thickness={4}
                        value={100}
                      />
                    </div>
                  )}
                </button>
                <button
                  className="btn-forgot-password"
                  onClick={() => {
                    setLoginAlert(false)
                    setRecoverPassword(true)
                  }}
                >
                  Esqueci a senha
                </button>
              </div>
              <div className="info-footer-login">
                <span>
                  Se você não está cadastrado, peça a liberação do seu e-mail à gerência do Broker.
                </span>
              </div>
            </CForm>
          </div>
          {loginAlert && (
            <CToast
              autohide={false}
              visible={true}
              color="danger"
              className={`text-white align-items-center alert-toast animate__animated ${alertAnimationClass}`}
            >
              <div className="d-flex">
                <CToastBody>{loginAlertMessage}</CToastBody>
                <CToastClose className="me-2 m-auto" white onClick={closeLoginAlert} />
              </div>
            </CToast>
          )}
        </>
      )}
      {recoverPassword && <RecoverPassword setRecoverPassword={setRecoverPassword} />}
    </div>
  )
}

export default Login
